import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
    toggle: String,
  };

  connect() {}

  toggleSetting() {
    patch(this.urlValue, { body: { toggle: this.toggleValue } });
  }
}
